/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ZoomOutIcon = /*#__PURE__*/ createSvgIcon(
  'ZoomOutIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.75 8.75a.728.728 0 01-.534-.214A.72.72 0 016 8.004c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h2.5c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-2.5zM8 13c-1.389 0-2.57-.486-3.542-1.458C3.486 10.569 3 9.389 3 8c0-1.389.486-2.57 1.458-3.542C5.431 3.486 6.611 3 8 3c1.389 0 2.57.486 3.542 1.458C12.514 5.431 13 6.611 13 8.001a4.78 4.78 0 01-.26 1.587 5.204 5.204 0 01-.72 1.37l4.46 4.459c.152.152.228.326.228.52a.718.718 0 01-.229.521.73.73 0 01-1.062 0l-4.459-4.437a5.204 5.204 0 01-1.37.719A4.78 4.78 0 018 13zm0-1.5c.972 0 1.799-.34 2.48-1.02.68-.681 1.02-1.508 1.02-2.48s-.34-1.799-1.02-2.48C9.798 4.84 8.971 4.5 8 4.5s-1.799.34-2.48 1.02C4.84 6.202 4.5 7.029 4.5 8s.34 1.799 1.02 2.48c.681.68 1.508 1.02 2.48 1.02z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ZoomOutIcon;
